import { ChevronRightIcon } from "@talladega/icons";

export const BreadCrumbs = ({
  items,
}: {
  items: { label: string; href?: string }[];
}) => {
  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex space-x-1 text-sm">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={item.label} className="flex items-center !mx-0">
              {item.href && !isLast ? (
                <a
                  href={item.href}
                  className="underline font-semibold fg-brand-primary"
                >
                  {item.label}
                </a>
              ) : (
                <span className="font-bold text-tertiary">{item.label}</span>
              )}
              {!isLast && (
                <ChevronRightIcon className="mx-2 fg-disabled text-base" />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default {};
